import axios from 'axios';
import {
	req,
	reqF,
} from './axiosFun';


// 分页获取订单信息
export const GetStoreOrderPageList = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/GetStoreOrderPageList", params)
};
// 获取订单详情
export const GetStoreOrderDetail = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/GetStoreOrderDetail", params)
};
// 生成订单编号
export const GenerateOrderNumber = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/GenerateOrderNumber", params)
};
// 创建订单
export const CreateStoreOrder = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/CreateStoreOrder", params)
};
// 修改订单
export const EditStoreOrder = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/EditStoreOrder", params)
};
// 退回订单
export const ReturnStoreOrder = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/ReturnStoreOrder", params)
};
// 提交订单
export const SubmitStoreOrder = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/SubmitStoreOrder", params)
};
// 确认订单
export const ConfirmStoreOrder = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/ConfirmStoreOrder", params)
};
// 审核订单
export const AuditStoreOrder = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/AuditStoreOrder", params)
};
// 管理员审核订单
export const AdminAuditStoreOrder = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/AdminAuditStoreOrder", params)
};
// 创建采购审核订单
export const CreatePurchaseAuditStoreOrder = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/CreatePurchaseAuditStoreOrder", params)
};
// 创建门店采购订单
export const CteateStorePurchaseOrder = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/CteateStorePurchaseOrder", params)
};
// 完成订单
export const FinishedStoreOrder = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/FinishedStoreOrder", params)
};
// 删除订单
export const DeleteStoreOrder = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/DeleteStoreOrder", params)
};
// 取消订单
export const CancelStoreOrder = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/CancelStoreOrder", params)
};
// 批量保存门店快递单号
export const BatchSaveStoreKDNo = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/BatchSaveStoreKDNo", params)
};
// 批量保存加工部快递单号
export const BatchSaveJGBKDNo = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/BatchSaveJGBKDNo", params)
};
// 修改订单加工渠道
export const UpdateMachinChannel = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/UpdateMachinChannel", params)
};
// 创建售后订单
export const CreateAfterSaleOrder = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/CreateAfterSaleOrder", params)
};
// 批量修改门店快递单号
export const BatchEditStoreKDNo = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/BatchEditStoreKDNo", params)
};

// 订单数量统计
export const GetStoreOrderNumStatistics = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/GetStoreOrderNumStatistics", params)
};
// 获取订单近30天的数量统计
export const GetStoreOrderNumMonthStatistics = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/GetStoreOrderNumMonthStatistics", params)
};
// 订单数量统计
export const GetStoreOrderStatistic = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/GetStoreOrderStatistic", params)
};
// 订单金额统计
export const GetStoreOrderMoneyStatistic = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/GetStoreOrderMoneyStatistic", params)
};
// 获取门店日订单数量统计
export const GetStoreOrderDayStatistic = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/GetStoreOrderDayStatistic", params)
};
// 获取加工部月度快递统计数据
export const GetJGBMonthKDStatistic = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/GetJGBMonthKDStatistic", params)
};
// 获取售后订单统计数据
export const GeyAfterSaleOrderStatistic = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/GeyAfterSaleOrderStatistic", params)
};


// 分页获取门店快递信息
export const GetStoreOrderKDList = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/GetStoreOrderKDList", params)
};
// 分页获取加工部快递信息
export const GetJGBKDList = (params) => {
	return reqF("post", "/api/sysConfig/StoreOrder/GetJGBKDList", params)
};


// 分页获取商品库存信息
export const GetGoodsWareHousePageList = (params) => {
	return reqF("post", "/api/sysConfig/WareHouse/GetGoodsWareHousePageList", params)
};
// 创建商品库存信息
export const CreateGoodsWareHouse = (params) => {
	return reqF("post", "/api/sysConfig/WareHouse/CreateGoodsWareHouse", params)
};
// 修改商品库存信息
export const UpdateGoodsWareHouse = (params) => {
	return reqF("post", "/api/sysConfig/WareHouse/UpdateGoodsWareHouse", params)
};
// 获取商品库存配置信息详情
export const GetGoodsWareQuantityConfigDetail = (params) => {
	return reqF("post", "/api/sysConfig/WareHouse/GetGoodsWareQuantityConfigDetail", params)
};
// 导出需采购的库存商品信息
export const ExportStockWarehouseGoods = (params) => {
	return reqF("post", "/api/sysConfig/WareHouse/ExportStockWarehouseGoods", params)
};
// 获取库存商品信息_二维表展示
export const GetTwoDimensionTable = (params) => {
	return reqF("post", "/api/sysConfig/WareHouse/GetTwoDimensionTable", params)
};
// 二维表的方式导出缺少常备数量的库存商品
export const ExportErWeiStockWarehouseGoods = (params) => {
	return reqF("post", "/api/sysConfig/WareHouse/ExportErWeiStockWarehouseGoods", params)
};
// 根据商品id获取商品库存信息详情
export const GetGoodsWareHouseDetail = (params) => {
	return reqF("post", "/api/sysConfig/WareHouse/GetGoodsWareHouseDetail", params)
};
//导出实时库存数据
export const ExportRealWarehouseGoods = (params) => {
	return reqF("post", "/api/sysConfig/WareHouse/ExportRealWarehouseGoods", params)
};
//修改库存商品数量
export const UpdateWareHouseQty = (params) => {
	return reqF("post", "/api/sysConfig/WareHouse/UpdateWareHouseQty", params)
};
//获取库存商品数量修改历史
export const GetWareHouseHistoryList = (params) => {
	return reqF("post", "/api/sysConfig/WareHouse/GetWareHouseHistoryList", params)
};